import { useContext, useEffect } from 'react'

import SelectDictionary from './selectDictionary'
import { CommonListType, ISelectDictionary, ISelectDictionaryContainer } from './selectDictionary.type'

import { useDict } from '../../../store/dict/dict.state'
import { NotificationContext, notifyOpen } from '../../ui/notification/notification.provider'
import { useInput } from '../../../hooks/useInput'
import { formatHours } from '../../../services/func.service'


/** Выбор из справочника - Контейнер */
const SelectDictionaryContainer = ({isOpen, dictName, whereID, handlerButtonCancel, returnSelectedData}: ISelectDictionaryContainer) => {
    const notify = useContext(NotificationContext)

    const { 
        isLoading, error, actionGetCourses, actionGetPrograms, clearDict,
        courseList, programList
    } = useDict()
    
    const headerText = useInput<string>('')
    const txtSearch = useInput<string>('')

    const selectedID = useInput<number>(0)
    const commonList = useInput<CommonListType[]>([])


    useEffect(() => {
        if (isOpen) {
            switch (dictName) {
                case 'courses': {
                    actionGetCourses()
                    headerText.setValue('Выбор курса')
                    break
                }

                case 'programs': {
                    actionGetPrograms(Number(whereID))
                    headerText.setValue('Выбор программы')
                    break
                }
            }
        }
        
        return (() => {
            clearDict()

            headerText.setValue('')
            txtSearch.setValue('')

            selectedID.setValue(0)
            commonList.setValue([])
        })
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (error) return notify && notifyOpen(error?.message, error?.type, 3000, notify)
    }, [error]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isOpen) {
            switch (dictName) {
                case 'courses': {
                    commonList.setValue(courseList.map((item) => ({
                        id: item.courseID,
                        name: item.courseName,
                    })))
                    break
                }

                case 'programs': {
                    commonList.setValue(programList.map((item) => {
                        let typeDurationEducation = 'недели'
                        if (item.volumeHours >= 250) {
                            typeDurationEducation = 'месяца'
                            if (item.durationEducation >= 5) typeDurationEducation = 'месяцев'
                        }

                        return {
                            id: item.courseProgramID,
                            name: `${formatHours(item.volumeHours)} (${item.durationEducation} ${typeDurationEducation})`,
                            substring: item.programName
                        }
                    }))
                    break
                }
            }
        }
    }, [courseList, programList]) // eslint-disable-line react-hooks/exhaustive-deps


    const handlerButtonOk = () => {
        const selectedCourse = commonList.value.filter(val => val.id === selectedID.value)
        if (selectedCourse.length === 0) return notify && notifyOpen('Для продолжения необходимо выбрать курс.', 'info', 3000, notify)

        returnSelectedData && returnSelectedData(selectedCourse[0].id, selectedCourse[0].name, selectedCourse[0].substring)
    }

    const propsToComponent: ISelectDictionary = {
        isOpen, isLoading,
        headerText: headerText.value, txtSearch, 
        selectedID, commonList,
        handlerButtonOk, handlerButtonCancel,
    }

    return <SelectDictionary {...propsToComponent} />
}

export default SelectDictionaryContainer